import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-page-technical-details-drawer',
  templateUrl: './page-technical-details-drawer.component.html',
  styleUrls: ['./page-technical-details-drawer.component.css']
})
export class PageTechnicalDetailsDrawerComponent implements OnInit {
  audit: any;
  history: any[] = [];
  loading = true;
  url = 'seoTechnicalAudits'

  constructor(
    public dialogRef: MatDialogRef<PageTechnicalDetailsDrawerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService
  ) {
    this.audit = data.audit;
  }

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory() {
    this.loading = true;
    this.dataService.getData(this.url + `/history/${this.audit.registryId._id || this.audit.registryId}`).subscribe(res => {
      if (res.rst) {
        this.history = res.data;
      }
      this.loading = false;
    });
  }

  getPriorityBadgeClass(p: string) {
    switch (p) {
      case 'P0': return 'badge-danger';
      case 'P1': return 'badge-warning';
      case 'P2': return 'badge-info';
      default: return 'badge-secondary';
    }
  }

  close() {
    this.dialogRef.close();
  }
}
